export const useDocumentContainerTopPosition = () => {
  try {
    var documentContainerElement =
      document.getElementById("document-container");
    if (!documentContainerElement) {
      return 0;
    }

    var documentBox = documentContainerElement.getBoundingClientRect();

    if (documentBox == undefined || documentBox.top == undefined) return 0;

    return documentBox.top;
  } catch (error) {
    return 0;
  }
};
